import React, { useState } from "react";
import { IoCalendarClear } from "react-icons/io5";
import moment from "moment";
import MonthlyGuidesModal from "./MonthlyGuidesModal";
import "./diversity-calendar.css"

export default function DiversityCalendar() {
  const [openGuidesModal, setOpenGuidesModal] = useState(false);
  return (
    <div className="diversity_calendar_container">
      <iframe
        src="https://calendar.google.com/calendar/embed?src=c_44a3b43b1addc411155c33944dc1835f34c72b1f1b1952d95909b53f84f7bf74%40group.calendar.google.com&ctz=America%2FLos_Angeles"
        style={{ border: 0 }}
        width="800"
        height="600"
        frameborder="0"
        scrolling="no"
      ></iframe>
      <div className="diversity_calendar_container_footer" />
      <div className="diversity_calendar_container_guide_btn_container">
        {" "}
        <div
          class="diversity_calendar_container_guide_btn"
          onClick={() => setOpenGuidesModal(true)}
        >
          See Guides 
          {/* for {moment().format("MMMM")} */}
          <IoCalendarClear size={"20px"} />
        </div>
      </div>

      {openGuidesModal && (
        <MonthlyGuidesModal
          currentMonth={moment().format("MMMM")}
          open={openGuidesModal}
          onClose={() => setOpenGuidesModal(false)}
        />
      )}
    </div>
  );
}
